import produce from "immer";
import React, { FC } from "react";
import { useState } from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import { uuid } from "uuidv4";
import {
  startAddFrom,
  startLoadForm,
  startRemoveForm,
} from "../../actions/formListAction";
import { startUpdateProject } from "../../actions/projectAction";
import { useAuth } from "../../contexts/authContext";
import { Form as FormModel } from "../../models/formModel";
import { Project } from "../../models/projectModel";
import { AppState } from "../../reducers/rootReducer";
import "./elementpanel.scss";
import FormComponent from "./utils/formComponent";

export interface FormPanelComponentProps {
  project: Project;
}

const FormPanelComponent: FC<FormPanelComponentProps> = ({ project }) => {
  const dispatch = useDispatch();
  const formState = useSelector((state: AppState) => state.formList);
  const sessionState = useSelector((state: AppState) => state.session);
  const [open, setOpen] = useState(false);
  const [formCreate, setFormCreate] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(undefined);
  const [accordionOn, setAccordionOn] = useState(false);
  const [modelCreate, setModelCreate] = useState(false);
  const [alertCreate, setAlertCreate] = useState(false);
  const [formName, setFormName] = useState("");
  const [modelName, setModelName] = useState("");
  const [alertName, setAlertName] = useState("");
  const [groupName, setGroupName] = useState("");
  const { authData } = useAuth();

  const formList = formState.filter((form) => {
    return form.type === "form";
  });

  const modelList = formState.filter((model) => {
    return model.type === "model";
  });

  const alertList = formState.filter((model) => {
    return model.type === "alert";
  });

  // adding new form
  const handleButtonCreateNewForm = () => {
    dispatch(
      startAddFrom({
        name: formName,
        projectId: sessionState.selectedProjectId,
        type: "form",
        modalAttribute: {},
        alertAttribute: {},
        createBy: authData ? authData.userName : "",
        groupId: selectedGroupId,
        saveAs: "user",
      })
    );
    setFormCreate(false);
  };

  // adding new group
  const handleButtonCreateNewGroup = () => {
    const group = {
      id: uuid(),
      name: groupName,
    };
    const newProject = produce(project, (draft) => {
      draft.groups.push(group);
    });
    dispatch(startUpdateProject(newProject));
    setOpen(false);
  };

  // adding new model
  const handleButtonCreateNewModel = () => {
    dispatch(
      startAddFrom({
        name: modelName,
        projectId: sessionState.selectedProjectId,
        type: "model",
        modalAttribute: { title: "", modalLarge: "", modelCentered: "" },
        alertAttribute: {},
        createBy: authData ? authData.userName : "",
        saveAs: "user",
      })
    );
    setModelCreate(false);
  };

  // adding new alert
  const handleButtonCreateNewAlert = () => {
    dispatch(
      startAddFrom({
        name: alertName,
        projectId: sessionState.selectedProjectId,
        type: "alert",
        createBy: authData ? authData.userName : "",
        saveAs: "user",
        modalAttribute: {},
        alertAttribute: {
          message: "",
          displayTime: 5,
          notificationType: "",
          position: "",
        },
      })
    );
    setAlertCreate(false);
  };

  // render project groups inside the form tab

  const renderProjectGroups = () => {
    return project.groups.map((group: any, index: number) => {
      return (
        // <Accordion defaultActiveKey="0">
        <Card className="theam-component">
          <Accordion.Toggle
            as={Button}
            variant={`${(selectedGroupId === group.id) ? "outline-primary" : "outline-dark"}`}
            className="theam-font"
            eventKey={group.id}
            onClick={(e) => {
              setSelectedGroupId(group.id);
            }}
          >
            <div className="row">
              <div className="col-7 text-align-justify">{group.name}</div>
              <div className="col-5 text-align-right">
                <i
                  className="fa fa-plus"
                  aria-hidden="true"
                  onClick={(e) => {
                    e.stopPropagation();
                    setFormCreate(true);
                    setSelectedGroupId(group.id);
                  }}
                ></i>
              </div>
            </div>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey={group.id}>
            <Card.Body>{renderGroupForms(group.id)}</Card.Body>
          </Accordion.Collapse>
        </Card>
        // </Accordion>
      );

      // <div className="card" key={`group-${group.id}`}>
      //   <div className="card-header" id={`heading-group-${group.id}`}>
      //     <h5 className="mb-0">
      //       <button
      //         className="btn btn-link"
      //         data-toggle="collapse"
      //         data-target={`#collapse-group-${group.id}`}
      //         aria-expanded="false"
      //         aria-controls={`collapse-group-${group.id}`}
      //       >
      //         {group.name}
      //       </button>
      //     </h5>
      //   </div>

      //   <div
      //     id={`collapse-group-${group.id}`}
      //     className={`collapse`}
      //     aria-labelledby={`heading-group-${group.id}`}
      //   >
      //     <div className="card-body custom-card-body">
      //       {renderGroupForms(group.id)}
      //     </div>
      //   </div>
      // </div>
    });
  };

  // render group forms

  const renderGroupForms = (groupId: string) => {
    const groupForms = formList.filter((form: FormModel) => {
      if (form.groupId === groupId) return form;
    });
    return groupForms.map((form, i) => {
      return <FormComponent form={form} groupList={project.groups} />;
    });
  };

  // render default group form

  const renderDefaultGroupForms = () => {
    const defaultGroupForms = formList.filter((form: FormModel) => {
      if (
        (form.groupId === null ||
        form.groupId === "" ||
        form.groupId === undefined )
      )
        return form;
    });
    return defaultGroupForms.map((form, i) => {
      return <FormComponent form={form} groupList={project.groups} />;
    });
  };
  return (
    <>
      <Tabs
        defaultActiveKey="forms"
        id="form-tab"
        className="inherit-padding-bottom"
        // variant="tabs"
      >
        <Tab
          eventKey="forms"
          title={"Forms"}
          tabClassName="padding-left-right-8 theme-tab-btn theam-font-tab btn-dark mr-1"
        >
          <div className="row">
            <div className="col-12 padding-0">
              <Accordion defaultActiveKey="0">
                {renderProjectGroups()}
                <Card className="theam-component">
                  <Accordion.Toggle
                    as={Button}
                    variant={`${(selectedGroupId === undefined) ? "outline-primary" : "outline-dark"}`}
                    className="theam-font"
                    eventKey={project.id}
                    onClick={(e) => {
                      setSelectedGroupId(undefined);
                    }}
                  >
                    <div className="row">
                      <div className="col-7 text-align-justify">
                        Default Group
                      </div>
                      <div className="col-5 text-align-right">
                        <i
                          className="fa fa-plus"
                          aria-hidden="true"
                          onClick={(e) => {
                            e.stopPropagation();
                            setFormCreate(true);
                            setSelectedGroupId(undefined);
                          }}
                        ></i>
                      </div>
                    </div>
                  </Accordion.Toggle>

                  <Accordion.Collapse eventKey={project.id}>
                    <Card.Body>{renderDefaultGroupForms()}</Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>

              {/* <div className="card" key={`${project.id}-default-group`}>
                <div className="card-header" id={`heading-${project.id}-default-group`}>
                  <h5 className="mb-0">
                    <button
                      className="btn btn-dark"
                      data-toggle="collapse"
                      data-target={`#collapse-${project.id}-default-group`}
                      aria-expanded="false"
                      aria-controls={`collapse-${project.id}-default-group`}
                    >
                      Default Group
                    </button>
                  </h5>
                </div>

                <div
                  id={`collapse-${project.id}-default-group`}
                  className={`collapse`}
                  aria-labelledby={`heading-${project.id}-default-group`}
                >
                  <div className="card-body custom-card-body">
                    {renderDefaultGroupForms()}
                  </div>
                </div>
              </div> */}
              {/* {formList
                ? formList.map((form, i) => (
                  <div
                    className="form-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(startLoadForm(form));
                    }}
                  >
                    <span
                      className={`form-name ${sessionState.selectedFormId === form.id
                        ? "form-active"
                        : ""
                        }`}
                    >
                      {form.name}
                    </span>
                    <button
                      className="form-remove"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(startRemoveForm(form.id));
                      }}
                    >
                      <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                  </div>
                ))
                : null} */}
            </div>
            <div className="col-8 m-2 p-2">
              <button
                type="button"
                className="form-button theam-font btn-dark theam-button"
                onClick={() => {
                  setFormCreate(true);
                }}
              >
                <i className="fa fa-plus-square-o" aria-hidden="true">
                  {" "}
                  <span className="roboto-font"> Add new Form</span>
                </i>
              </button>
            </div>
          </div>
        </Tab>
        <Tab
          eventKey="models"
          title={"Modal"}
          tabClassName="padding-left-right-8 theme-tab-btn theam-font-tab btn-dark mr-1"
        >
          <div className="row">
            <div className="col-12">
              {modelList
                ? modelList.map((model, i) => (
                    <div
                      className="form-item theam-font"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(startLoadForm(model));
                      }}
                    >
                      <span
                        className={`form-name ${
                          sessionState.selectedFormId === model.id
                            ? "form-active"
                            : ""
                        }`}
                      >
                        {model.name}
                      </span>
                      <Tooltip title="Remove">
                        <button
                          className="form-remove theam-dark-btn btn-dark"
                          onClick={(e) => {
                            e.stopPropagation();
                            dispatch(startRemoveForm(model.id));
                          }}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </Tooltip>
                    </div>
                  ))
                : null}
            </div>
            <div className="col-8 m-2 p-2">
              <button
                type="button"
                className="form-button btn-dark theam-button theam-font"
                // onClick={handleButtonCreateNewModel}
                onClick={() => {
                  setModelCreate(true);
                }}
              >
                <i className="fa fa-plus-square-o" aria-hidden="true">
                  <span className="roboto-font"> Add new Modal</span>
                </i>
              </button>
            </div>
          </div>
        </Tab>
        <Tab
          eventKey="alerts"
          title={"Alerts"}
          tabClassName="padding-left-right-8 theme-tab-btn theam-font-tab btn-dark"
        >
          <div className="row">
            <div className="col-12">
              {alertList
                ? alertList.map((model, i) => (
                    <div
                      className="form-item theam-font"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(startLoadForm(model));
                      }}
                    >
                      <span
                        className={`form-name ${
                          sessionState.selectedFormId === model.id
                            ? "form-active"
                            : ""
                        }`}
                      >
                        {model.name}
                      </span>
                      <button
                        className="form-remove theam-dark-btn btn-dark"
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(startRemoveForm(model.id));
                        }}
                      >
                        <Tooltip title="Remove">
                          <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </Tooltip>
                      </button>
                    </div>
                  ))
                : null}
            </div>
            <div className="col-8 m-2 p-2">
              <button
                type="button"
                className="form-button btn-dark theam-button theam-font"
                // onClick={handleButtonCreateNewAlert}
                onClick={() => {
                  setAlertCreate(true);
                }}
              >
                <i className="fa fa-plus-square-o" aria-hidden="true">
                  <span className="roboto-font"> Add new Alert</span>
                </i>
              </button>
            </div>
          </div>
        </Tab>
      </Tabs>
      {/* <button
        type="button"
        onClick={() => {setOpen(true)}}
      >
        <i className="fa fa-plus-square-o" aria-hidden="true"></i>
      </button> */}
      {open && (
        <Modal
          size={"sm"}
          isOpen={open}
          show={open}
          onHide={() => {
            setOpen(false);
          }}
        >
          <Modal.Header className="theam-btn">
            <Modal.Title>Create Form Group</Modal.Title>
          </Modal.Header>
          <Modal.Body className="theam-btn">
            <Container>
              <Form.Row className="text-right">
                <Col sm={12}>
                  <Form.Group as={Row} controlId="firstName">
                    {/* <Form.Label column sm={4}>
                      Group Name
                    </Form.Label> */}
                    <Col sm={12}>
                      <Form.Control
                        type="text"
                        className="form-control theam-textbox"
                        placeholder="Add New Group Name"
                        onChange={(e) => {
                          setGroupName(e.target.value);
                        }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Row>
            </Container>
          </Modal.Body>
          <Modal.Footer className="theam-btn">
            <Button
              variant="btn-dark theam-btn theam-font"
              type="btn"
              onClick={handleButtonCreateNewGroup}
            >
              Add
            </Button>
            <Button
              variant="btn-dark theam-btn theam-font"
              type="btn"
              onClick={() => {
                setOpen(false);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {formCreate && (
        <Modal
          size={"sm"}
          isOpen={formCreate}
          show={formCreate}
          onHide={() => {
            setFormCreate(false);
          }}
        >
          <Modal.Header className="theam-btn">
            <Modal.Title>Create Form</Modal.Title>
          </Modal.Header>
          <Modal.Body className="theam-btn">
            <Container>
              <Form.Row className="text-right">
                <Col sm={12}>
                  <Form.Group as={Row} controlId="firstName">
                    {/* <Form.Label column sm={4}>
                      Form Name
                    </Form.Label> */}
                    <Col sm={12}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Form Name"
                        className="form-control theam-textbox"
                        onChange={(e) => {
                          setFormName(e.target.value);
                        }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Row>
            </Container>
          </Modal.Body>
          <Modal.Footer className="theam-btn">
            <Button
              variant="dark theam-btn theam-font"
              type="btn"
              onClick={handleButtonCreateNewForm}
            >
              Add
            </Button>
            <Button
              variant="dark theam-btn theam-font"
              type="btn"
              onClick={() => {
                setFormCreate(false);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {modelCreate && (
        <Modal
          size={"sm"}
          isOpen={modelCreate}
          show={modelCreate}
          onHide={() => {
            setModelCreate(false);
          }}
        >
          <Modal.Header className="theam-btn">
            <Modal.Title>Create Model</Modal.Title>
          </Modal.Header>
          <Modal.Body className="theam-btn">
            <Container>
              <Form.Row className="text-right">
                <Col sm={12}>
                  <Form.Group as={Row} controlId="firstName">
                    {/* <Form.Label column sm={4}>
                      Form Name
                    </Form.Label> */}
                    <Col sm={12}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Model Name"
                        className="form-control theam-textbox"
                        onChange={(e) => {
                          setModelName(e.target.value);
                        }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Row>
            </Container>
          </Modal.Body>
          <Modal.Footer className="theam-btn">
            <Button
              variant="dark theam-btn theam-font"
              type="btn"
              onClick={handleButtonCreateNewModel}
            >
              Add
            </Button>
            <Button
              variant="dark theam-btn theam-font"
              type="btn"
              onClick={() => {
                setModelCreate(false);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {alertCreate && (
        <Modal
          size={"sm"}
          isOpen={alertCreate}
          show={alertCreate}
          onHide={() => {
            setAlertCreate(false);
          }}
        >
          <Modal.Header className="theam-btn">
            <Modal.Title>Create Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body className="theam-btn">
            <Container>
              <Form.Row className="text-right">
                <Col sm={12}>
                  <Form.Group as={Row} controlId="firstName">
                    {/* <Form.Label column sm={4}>
                      Form Name
                    </Form.Label> */}
                    <Col sm={12}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Alert Name"
                        className="form-control theam-textbox"
                        onChange={(e) => {
                          setAlertName(e.target.value);
                        }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Row>
            </Container>
          </Modal.Body>
          <Modal.Footer className="theam-btn">
            <Button
              variant="dark theam-btn theam-font"
              type="btn"
              onClick={handleButtonCreateNewAlert}
            >
              Add
            </Button>
            <Button
              variant="dark theam-btn theam-font"
              type="btn"
              onClick={() => {
                setAlertCreate(false);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default FormPanelComponent;
